import React, { Component } from "react";
import propTypes from "prop-types";

export default class Countdown extends Component {
  constructor(props) {
    super(props);
    this.state = { seconds: this.props.seconds };

    this.tick = this.tick.bind(this);
  }

  tick() {
    if (this.state.seconds < 1) {
      clearInterval(this.interval);
      this.props.onFinish();
      return;
    }
    this.setState((prevState) => ({
      seconds: prevState.seconds - 1
    }));
  }

  componentDidMount() {
    this.interval = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return this.state.seconds > 0 ? (
      <div className={this.props.className}>{this.state.seconds}</div>
    ) : null;
  }
}
Countdown.propTypes = {
  className: propTypes.string.isRequired,
  seconds: propTypes.number.isRequired,
  onFinish: propTypes.func.isRequired
};
